<template>
  <div>
    <div class="page">
      <div class="wrapper">
        <div class="content">
          <div class="top-fixed b1">
            <!--筛选条件-->
            <div class="jinNang-filter">
              <!--类型-->
              <div class="filter-row">
                <div class="filter-row-type">
                  <div class="filter-type-item s7 t1">类型</div>
                </div>
                <div class="filter-row-content">
                  <div
                    class="filter-item-wrap"
                    v-for="(item, index) in riskList"
                    :key="index"
                  >
                    <div
                      class="item-bottom-10 filter-item"
                      @click="riskSelect(item, index)"
                      :class="{'select-item': activeRisk == item.value}"
                    >{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!--风格-->
              <div class="filter-row">
                <div class="filter-row-type">
                  <div class="filter-type-item s7 t1">风格</div>
                </div>
                <div class="filter-row-content">
                  <div
                    class="filter-item-wrap"
                    v-for="(item, index) in styleList"
                    :key="index"
                  >
                    <div
                      class="item-bottom-10 filter-item"
                      @click="styleSelect(item, index)"
                      :class="{'select-item': item.selected}"
                    >{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 二级筛选 -->
            <ul class="sort-key-tabs">
              <li
                class="sort-key-tab"
                v-for="(item, index) in sortKeyList"
                :key="index"
                :class="{
              'sort-key-tab-active': activeSortKey === index,
              ascending:
                activeSortKey === index &&
                item.direction === SortDirection.ascending,
              descending:
                activeSortKey === index &&
                item.direction === SortDirection.descending
            }"
                @click.stop="changeSortKey(item, index)"
              >
                <div class="sort-key-name">{{ item.name }}</div>
                <div class="caret-wrapper" v-show="item.canSort">
                  <span class="sort-caret ascending"></span>
                  <span class="sort-caret descending"></span>
                </div>
                <div class="more" v-if="item.more"></div>
              </li>
            </ul>
            <!-- 二级次级筛选 -->
            <div class="bj-wrap" v-if="show">
              <div class="sub-sort-wrap b1">
                <div
                  class="sub-sort"
                  v-for="(item,index) in subList"
                  :key="index"
                  :class="{'choose':subIndex===index}"
                  @click="changeSubSortIndex(index)"
                >{{item.name}}</div>
              </div>
            </div>
          </div>

          <!--锦囊列表-->
          <div class="jinNang-list">
            <div class="item-list">
              <van-list
                v-model="loading"
                :finished="pageEnd"
                finished-text="加载完毕"
                @load="onLoad"
              >
                <jin-nang-list-item
                  class="mb-item"
                  v-for="(item, index) in jinNangList"
                  :key="index"
                  :item="item"
                  :sortType="sortType"
                  :jinNangId="item.jinNangId"
                  :title="item.title"
                  :tags="item.tags"
                  :glYield="item.glYield"
                  :yearYield="item.yearYield"
                  :authorName="item.authorName"
                  :authorTitle="item.authorTitle"
                  :authorCompany="item.authorCompany"
                  :selwinidx="item.selwinidx"
                  :maxdrawidx="item.maxdrawidx"
                  :createTime="item.createTime"
                  :lastOperateTime="item.lastOperateTime"
                  @goto="goto(`/jinNang/${item.jinNangId}`)"
                ></jin-nang-list-item>
              </van-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getJinNangList } from '@/api/jinNangList'
import JinNangListItem from '@/components/JinNang/JinNangListItem.vue'

/**
 * 排序方向
 * @type {{ascending: number, descending: number}}
 */
const SortDirection = {
  /**
   * 无效
   */
  none: 0,
  /**
   * 升序
   */
  ascending: 1,
  /**
   * 降序
   */
  descending: 2
}
export default {
  name: 'JinNang',
  components: { JinNangListItem },
  data() {
    return {
      SortDirection,
      activeRisk: null,
      activeSortKey: 0,
      jinNangList: [],
      viewState: '',
      pageEnd: false,
      riskList: [
        { name: '全部', value: null },
        { name: '稳健型', value: 1 },
        { name: '积极型', value: 2 },
        { name: '激进型', value: 3 }
      ],
      styleList: [
        { name: '波段操作', value: 1, selected: false },
        { name: '中短线', value: 2, selected: false },
        { name: '中长线', value: 3, selected: false },
        { name: '基本面', value: 4, selected: false },
        { name: '趋势交易', value: 5, selected: false },
        { name: '量化投资', value: 6, selected: false },
        { name: '价值成长', value: 7, selected: false },
        { name: '热点题材', value: 8, selected: false },
        { name: '其它', value: 0, selected: false }
      ],
      sortKeyList: [
        {
          name: '推荐',
          type: 99,
          direction: SortDirection.descending,
          canSort: false
        },
        {
          name: '周',
          type: 2,
          direction: SortDirection.descending,
          canSort: false
        },
        {
          name: '月',
          type: 3,
          direction: SortDirection.descending,
          canSort: false
        },
        {
          name: '年',
          type: 5,
          direction: SortDirection.descending,
          canSort: false
        },
        {
          name: '更多',
          type: 5,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        }
      ],
      subList: [
        {
          name: '日收益',
          type: 1,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        },

        {
          name: '季收益',
          type: 4,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        },

        {
          name: '总收益',
          type: 0,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        },
        {
          name: '最新打理',
          type: 10,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        },
        {
          name: '最早创建',
          type: 11,
          direction: SortDirection.ascending,
          canSort: false,
          more: true
        },
        {
          name: '最新创建',
          type: 11,
          direction: SortDirection.descending,
          canSort: false,
          more: true
        }
      ],
      sortType: 0,
      subIndex: -1,
      loading: false,
      show: false
    }
  },
  mounted() {
    const appId = this.$route.query.appId
    const wxAppId = this.$route.query.wxAppId
    if (appId) {
      localStorage.setItem('currentAppId', appId)
      localStorage.setItem('wxAppId', wxAppId)
    }
  },
  methods: {
    changeSubSortIndex(index) {
      this.subIndex = index
      const item = this.subList[index]
      this.sortType = item.type
      this.sortKeyList.splice(4, 1, {
        name: item.name,
        type: item.type,
        direction: item.direction,
        canSort: false,
        more: true
      })
      // 重置页码
      this.viewState = ''
      // 一级筛选处于选中
      this.activeSortKey = 4

      this.getJinNangList()
      //关闭弹窗
      this.show = false
    },
    showPopup() {
      this.show = !this.show
    },
    riskSelect(item) {
      this.activeRisk = item.value
      this.viewState = ''
      this.getJinNangList()
    },
    styleSelect(item, index) {
      this.styleList.splice(index, 1, {
        ...item,
        selected: !item.selected
      })
      this.viewState = ''
      this.getJinNangList()
    },
    changeSortKey(item, index) {
      // 点击更多
      if (index === 4) {
        this.showPopup()
        return
      }
      this.show = false
      this.sortType = item.type
      this.sortKeyList.splice(index, 1, {
        ...item,
        direction: item.direction
      })
      this.activeSortKey = index
      this.viewState = ''
      this.getJinNangList()
    },
    async getJinNangList() {
      this.loading = true

      const sortKey = this.sortKeyList[this.activeSortKey]
      const style = this.styleList
        .filter(a => a.selected && a.value !== null)
        .map(a => a.value)
      const level = this.riskList.find(a => a.value === this.activeRisk).value

      const data = await getJinNangList(
        {
          sortKind: sortKey.type,
          orderBy: sortKey.direction,
          direction: this.viewState ? 2 : 0,
          styles: style.length === 0 ? null : style,
          levels: level === null ? null : [level]
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          const orignalViewState = this.viewState
          if (data.detail.flush || orignalViewState === '') {
            this.jinNangList = data.detail.list
          } else {
            this.jinNangList = this.jinNangList.concat(data.detail.list)
          }
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end
          this.loading = false
          // setTimeout(() => (this.loading = false), 50)
        }
      }
    },
    async onLoad() {
      await this.getJinNangList()
    },
    goto(router) {
      this.$router.push(router)
    }
  }
}
</script>

<style lang="scss" scoped>
.bj-wrap {
  // position: fixed;
  // left: 0;
  // top: 430px;
  position: absolute;
  left: 0;
  top: 418px;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  .sub-sort-wrap {
    display: flex;
    padding: 30px;
    flex-wrap: wrap;
    .sub-sort {
      width: 22%;
      margin-right: 3%;
      font-size: 24px;
      height: 50px;
      color: #858585;
      background-color: rgba(85, 85, 85, 0.1);
      border-radius: 5px;
      line-height: 50px;
      text-align: center;
      letter-spacing: 1px;
      flex: none;
      box-sizing: border-box;
      margin-bottom: 24px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &.choose {
        border: 1px solid #0079ff;
        color: #0079ff;
        background: #ffffff;
      }
    }
  }
}
.top-fixed {
  position: fixed;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: flex-start;
  // margin-top: 30px;
  // margin-left: 30px;
}
.content {
  flex: auto;
  display: flex;
  flex-direction: column;
}
.jinNang-filter {
  flex: auto;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 30px 30px 0;
  max-width: 750px;
  box-sizing: border-box;
}
.filter-row {
  flex: auto;
  align-items: flex-start;
  display: flex;
  margin-bottom: 6px;
}
.filter-row-type {
  flex: none;
  flex-basis: 80px;
  display: flex;
}
.filter-type-item {
  align-items: flex-start;
  letter-spacing: 1px;
  margin-top: 10px;
}
.filter-row-content {
  display: flex;
  align-items: center;
  align-content: space-between;
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 1;
}
.filter-row-content div {
  font-size: 24px;
  color: #858585;
}
.filter-item-wrap {
  width: 22%;
  margin-right: 3%;
  &:nth-child(4n) {
    margin-right: 0;
  }
}
.filter-item {
  height: 50px;
  color: #858585;
  background-color: rgba(85, 85, 85, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  box-sizing: border-box;
}

.item-bottom-10 {
  margin-bottom: 24px;
}

.select-item {
  border: 1px solid #0079ff;
  color: #0079ff;
  background: #ffffff;
}
.jinNang-list {
  flex: auto;
  padding-top: 426px;
  .item-list {
    padding: 30px 30px 0;
  }
}
.mb-item {
  margin-bottom: 30px;
}
.sort-key-tabs {
  font-size: 32px;
  height: 80px;
  line-height: 82px;
  letter-spacing: 1px;
  color: #262626;
  display: flex;
  border-top: 10px solid #f0f0f0;
  border-bottom: 1px solid #ebebeb;
  list-style: none;
  padding: 0 30px 0 50px;
  justify-content: space-between;
  max-width: 750px;
  box-sizing: border-box;

  .sort-key-tab {
    cursor: pointer;
    text-align: center;
    display: flex;
    align-items: center;
    .more {
      width: 20px;
      height: 30px;
      background: url('./images/more.png') no-repeat left bottom;
      background-size: 10px 10px;
    }
  }
  .sort-key-tab-active {
    font-weight: bold;
    color: #046bcc;
    // border-bottom: 2px solid #046bcc;
    .sort-key-name {
      position: relative;
      &::after {
        position: absolute;
        left: -1px;
        bottom: 1px;
        content: '';
        width: 100%;
        height: 8px;
        border-radius: 5px;
        background-color: #046bcc;
      }
    }
  }

  .sort-key-name {
    display: inline-flex;
    align-items: center;
    // margin-right: 15px;
    justify-content: center;
  }
}
.caret-wrapper {
  display: inline-flex;
  height: 34px;
  width: 24px;
  overflow: initial;
  position: relative;

  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;

    &.ascending {
      border-bottom-color: #c0c4cc;
      top: 5px;
    }

    &.descending {
      border-top-color: #c0c4cc;
      bottom: 7px;
    }

    .ascending &.ascending {
      border-bottom-color: #409eff;
    }

    .descending &.descending {
      border-top-color: #409eff;
    }
  }
}
</style>
